<ng-container *ngIf="messageService && messageService.spinnerOn">
  <app-spinner-new [logo]="logo"></app-spinner-new>
  <!-- <app-spinner-legacy *ngIf="!embedded"></app-spinner-legacy> -->
</ng-container>